import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function EmptyState({
  icon = "ri-file-search-line",
  title,
  description,
  primaryLabel = "返回首页",
  primaryTo = "/",
  secondaryLabel,
  secondaryTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-20 px-4">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-400 mb-5">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h2 className="text-lg md:text-xl font-semibold text-foreground-900">{title}</h2>
      <p className="mt-2 text-sm text-foreground-500 max-w-md leading-6">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to={primaryTo}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-4-line"></i>
          {primaryLabel}
        </Link>
        {secondaryLabel && secondaryTo && (
          <Link
            to={secondaryTo}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors"
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}